export const sliderWrapper = {
  cursor: 'pointer',
  height: '13px',
  paddingLeft: '6px',
  paddingRight: '6px',
  textAlign: 'left',
};

export const selectable = {
  overflowY: 'hidden',
  height: '100%',
  width: '100%',
};

export const sliderPath = {
  marginTop: '4px',
  width: '100%',
  height: '5px',
  overflow: 'hidden',
};

export const sliderShadow = {
  pointerEvents: 'none',
  height: '100%',
  transformOrigin: 'left',
};

export const thumb = {
  position: 'absolute',
  marginTop: '-12.5px',
  marginLeft: '-6px',
  width: '12px',
  height: '12px',
  borderRadius: '25px',
};



// WEBPACK FOOTER //
// ./src/style.js